$(function() {

    $('#__moderation__-decline').click(function(e) {
        e.preventDefault();

        var form1 = $(this).parent();
        var form2 = form1.next();

        form1.slideUp();
        form2.slideDown();
    });

    $('#__moderation__-accept').click(function(e) {
        e.preventDefault();

        var form1 = $(this).parent();
        var form2 = form1.next().next();

        form1.slideUp();
        form2.slideDown();
    });

    $('[data-action="cancel"]').click(function(e) {
        e.preventDefault();

        var form1 = $(this).parents('form');
        var form2 = form1.parent().children('div').eq(0);

        form1.slideUp();
        form2.slideDown();
    });

    $('.__moderation__-form_decline [data-action="decline"]').click(function(e) {

    });

});